import { useState } from "react";
import { Search, Loader2 } from "lucide-react";

export const UstSearch = ({ busy, onSearch, t }) => {
  const [q, setQ] = useState("");
  const [place, setPlace] = useState("");
  const submit = (e) => { e.preventDefault(); if (place.trim().length >= 2) onSearch(q.trim(), place.trim()); };
  return (
    <form className="card ust-search" onSubmit={submit} data-testid="ust-search-form">
      <div className="label">{t("Or search for a store")}</div>
      <input className="text-input" value={q} maxLength={60} onChange={(e) => setQ(e.target.value)}
        placeholder={t("Store name or address (e.g. Circle K, 4801 Gandy)")} data-testid="ust-search-q" />
      <input className="text-input" value={place} maxLength={60} required minLength={2} onChange={(e) => setPlace(e.target.value)}
        placeholder={t("City, state or ZIP (e.g. Tampa, FL or 33602)")} data-testid="ust-search-place" />
      <button type="submit" className="ghost-btn ust-search-btn" disabled={busy || place.trim().length < 2} data-testid="ust-search-btn">
        {busy ? <Loader2 size={16} className="spin" /> : <Search size={16} />}{t("Search")}
      </button>
    </form>
  );
};
